import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { deleteGroups } from '../actions/GroupMenuActions';
import { IGroupInfo } from '../models/IGroupInfo';
import { GrantLicenseModes } from '../serverApi/requests/SyncActiveDirectoryGroupRequest';

export const GroupDeleteAction: IEntityAction<IGroupInfo, {}> = {
  name: EntityActionNames.DeleteGroup,
  translateName: Messages.deleteGroup_action,
  isVisible: (targetItems: IGroupInfo[], state: AppState) => {
    if (state.spaceInfo.spaceType === 'group' || state.spaceInfo.spaceType === 'groups') {
      const targetItemsWithoutAllUsersGroup = targetItems.filter(group => !group.isAllUsersGroup);
      return targetItemsWithoutAllUsersGroup.length >= 1;
    }
    return false;
  },
  isClickable: (availableActions: {}, targetItems: IGroupInfo[], _state: AppState) =>
    getSessionManagementServiceInstance().canSessionManageUsersOrActOnResource('Group', ['DELETE_GROUP'])
    || hasGroupsWithoutLicenseUponLoginOnly(targetItems),
  createReduxAction: (targetItems: IGroupInfo[]) => deleteGroups(targetItems)
};

function hasGroupsWithoutLicenseUponLoginOnly(groups: IGroupInfo[]): boolean {
  const result = groups.filter(group => !group.grantLicenseMode || group.grantLicenseMode === GrantLicenseModes.ON_SYNC).length;
  return result === groups.length;
}
